<template>
  <div style="max-width: 100%; margin: auto;">
    <div class="ma-auto">
      <div class="d-flex align-center my-4">
        <h3 style="margin-right: 15px;">تاکسی 133</h3>
      </div>
    </div>

    <div class="page-f">
    <div class="AllSystemAutoFor">
      <div :style="BtnSelect1" @click="ChangeButton(1)" class="AllSystemAutoForChild">
        سرویس های امروز
      </div>

      <div :style="BtnSelect2" @click="ChangeButton(2)" class="AllSystemAutoForChild">
        کل سرویس ها
      </div>
    </div>


    <div v-if="step == 2 && ServiceList.length>0&&!loading">
      <div v-for="(ServiceLists,index) in ServiceList" :key="index"
           class="container-fluid ma-5" style="background-color: white; border-radius: 10px">
        <div class="row text-center">
          <div class="col-2" style="margin-right: 20px">
            <img  src="app/apple-touch-icon.png" style="width: 60px" />
          </div>
          <div class="col-7">
            <h3 class="mb-3">شماره سرویس: {{ServiceLists.service_id}}</h3>
            <h5 class="mb-3">{{ServiceLists.service_date}}</h5>
            <h4 class="mb-3 red--text">سرویس تکمیل شده</h4>
            <h4 class="mb-3 blue--text">{{ServiceLists.nickname}}</h4>
            <div style="margin-top: 20px" class="d-flex flex-column align-center">
              <router-link  :to="{ name: 'servicedetail', params: { id: ServiceLists.service_id } }" style="color:white; background-color: #ff9c04; padding:10px; border-radius:10px; width:295px; text-decoration-line: none">جزییات سرویس</router-link>
            </div>
          </div>
          <div class="col-3"></div>
        </div>
      </div>

      <div @click="userMethod" v-if="ServiceList.length>0&&loadmore&&!loading"  class="LoadLazyAdd">
        نمایش بیشتر
      </div>
      <v-row v-if="ServiceList.length===0&&!loading" class="justify-center align-center mt-4" style="height:90%">

        <div>
          <v-img
              src="/app/img/notfound.jpg"
              alt="Alt text"
              width="320"
              height="280"
          ></v-img>
        </div>

      </v-row>
      <v-row v-if="ServiceList.length===0&&loading" class="justify-center align-center mt-3" style="height:90%">

        <v-progress-linear  indeterminate style="    height: 5px;
    width: 82%;
    margin-top: 10rem;"></v-progress-linear>

      </v-row>
    </div>

    <div v-if="step == 1 && ServiceList1.length>0&&!loading">
      <div
           v-for="(ServiceLists,index) in ServiceList1" :key="index"
           class="container-fluid ma-5" style="background-color: white; border-radius: 10px">
        <div class="row text-center">
          <div class="col-2" style="margin-right: 20px">
            <img  src="app/apple-touch-icon.png" style="width: 60px" />
          </div>
          <div class="col-7">
            <h3 class="mb-3">شماره سرویس: {{ServiceLists.service_id}}</h3>
            <h5 class="mb-3">{{ServiceLists.service_date}}</h5>
            <h4 class="mb-3 red--text">سرویس تکمیل شده</h4>
            <h4 class="mb-3 blue--text">{{ServiceLists.nickname}}</h4>
            <div style="margin-top: 20px" class="d-flex flex-column align-center">
              <router-link :to="{ name: 'servicedetail', params: {id: ServiceLists.service_id} }" style="color:white; background-color: #ff9c04; padding:10px; border-radius:10px; width:295px; text-decoration-line: none">جزییات سرویس</router-link>

            </div>
          </div>
          <div class="col-3"></div>
        </div>
      </div>

      <div @click="userMethod1" v-if="ServiceList1.length>0&&loadmore&&!loading"  class="LoadLazyAdd">
        نمایش بیشتر
      </div>
      <v-row v-if="ServiceList1.length===0&&!loading" class="justify-center align-center mt-3" style="height:90%">

        <div>
          <v-img
              src="/app/img/notfound.jpg"
              alt="Alt text"
              width="320"
              height="280"
          ></v-img>
        </div>

      </v-row>
      
      <v-row v-if="ServiceList1.length===0&&loading" class="justify-center align-center mt-3" style="height:90%">
      <v-progress-linear  indeterminate style="    height: 5px;
      width: 82%;
      margin-top: 10rem;"></v-progress-linear>
      </v-row>
    </div>
    <SocketListner ref="MySocketListner" />
    <AndroidGeolocation  />
    </div>
  </div>

</template>

<script>
import {mapGetters} from "vuex";
import SocketListner from "../components/SocketListner.vue";
import AndroidGeolocation from "../components/AndroidGeolocation.vue";

export default {
  components: {
    SocketListner,
    AndroidGeolocation,
  },
  data(){
    return{
      dropArea : null,
      ServiceList : [],
      ServiceList1 : [],
      BtnSelect1 : '',
      BtnSelect2 : '',
      step : 1,
      PageShow: 0,
      PageShow1: 0,
      time: '',
      loadmore:false,
      loading:true,
    }
  },
  mounted() {
    setInterval(() => {
      const now = new Date();
      const options = { hour: 'numeric', minute: 'numeric' };
      this.time = now.toLocaleTimeString([], options);
    }, 1000);
    let self = this;
      self.getInfo();
      self.userMethod();
      self.userMethod1();
      self.ChangeButton(1);
      self.dropArea = document.getElementById('drop-area');
  },
  beforeDestroy() {
    console.log('beforeDestroy');
    SocketListner.disconnect();
  },
  computed: {
    ...mapGetters(['baseUrl', "auth"]),
  },
  methods:{
    ChangeButton(value){
      if (value == 1){
        this.step = value
        this.BtnSelect2 = ''
        this.BtnSelect1 = 'background: rgb(255, 156, 4) !important; color: white;'
      }else {
        this.step = value
        this.BtnSelect1 = ''
        this.BtnSelect2 = 'background: rgb(255, 156, 4) !important; color: white;'
      }
    },
    getInfo() {
      this.userBox = JSON.parse(localStorage.getItem('auth'));
    },
    userMethod(){
      this.loadmore=true
      this.PageShow += 1
      fetch(this.baseUrl + '/service-list?token=' + this.userBox.token + '&public_token=' + this.userBox.public_token + '&uid=' + this.userBox.uid + '&list_type=all' + '&page=' + this.PageShow)
          .then(response => response.json())
          .then(json =>{
            if (json.msg == "سرویسی یافت نشد"){
              this.PageShow -= 1
            }else {

              this.ServiceList= this.ServiceList.concat(json.data.list);
              if (json.data.total_page===this.PageShow){
                this.loadmore=false
              }
            }
            this.loading=false
          })
    },
    userMethod1(){
      this.loadmore=true
      this.PageShow1 += 1
      fetch(this.baseUrl + '/service-list?token=' + this.userBox.token + '&public_token=' + this.userBox.public_token + '&uid=' + this.userBox.uid + '&list_type=today' + '&page=' + this.PageShow1)
          .then(response => response.json())
          .then(json =>{
            if (json.msg == "سرویسی یافت نشد"){
              this.PageShow1 -= 1
            }else {
              // json.data.list.forEach((value) => {
              //   this.ServiceList1.push(value);
              // });

              this.ServiceList1= this.ServiceList1.concat(json.data.list);
              if (json.data.total_page===this.PageShow1){
                this.loadmore=false
              }
            }
            this.loading=false
          })
    },
  }
};
</script>

<style scoped>
.AllSystemAutoFor{
  display: grid;
  grid-template-columns: 47.5% 47.5%;
  justify-content: space-between;
  height: 60px;
  padding: 0 6%;
}

.AllSystemAutoForChild{
  height: 50px;
  background: rgba(255, 156, 4 , .3) !important;
  text-align: center;
  border-radius: 5px;
  line-height: 47px;
  color: black;
  cursor: pointer;
}
.LoadLazyAdd{
  margin: auto;
  width: 50%;
  height: 40px;
  border-radius: 30px;
  text-align: center;
  background: rgb(86, 146, 183);
  margin-top: 30px;
  line-height: 38px;
  color: white;
  cursor: pointer;
}
.page-f{

  height: calc(100vh - 115px);
  overflow: auto;

}
</style>
